import { render } from "./ViewReport.vue?vue&type=template&id=b3c62620&scoped=true"
import script from "./ViewReport.vue?vue&type=script&lang=js"
export * from "./ViewReport.vue?vue&type=script&lang=js"

import "./ViewReport.vue?vue&type=style&index=0&id=b3c62620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c62620"]])

export default __exports__